package com.bikompanion.ui.mapper

/**
 * What a looked-up bike's votes come to, shaped for the rating dialog to show in one line.
 */
data class BikeScoreSummaryUiModel(
    val bikeNumber: String,
    val verdict: BikeScoreVerdict,
    val tone: BikeScoreTone,
    val percentPositive: Int,
    val ratingCount: Int,
)
